import gql from 'graphql-tag';
import { query } from 'services/graphql';

export const aiQuery = gql`
  query aiQuestion($input: AiInput) {
    aiQuestion(input: $input) {
      templateId
    }
  }
`;

export default query(aiQuery);
